var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM17 10C17 12.7778 12 20 12 20C12 20 7 12.7778 7 10C7 7.22217 9.22222 5 12 5C14.7778 5 17 7.22222 17 10ZM13.9444 10.2779C13.9444 11.3517 13.0739 12.2223 12 12.2223C10.9261 12.2223 10.0555 11.3517 10.0555 10.2779C10.0555 9.20396 10.9261 8.33341 12 8.33341C13.0739 8.33341 13.9444 9.20396 13.9444 10.2779Z",
    fill: "#393D47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLocation);
export default __webpack_public_path__ + "static/media/circleLocation.a2b49a1002f1c85d3c6f891f66308edf.svg";
export { ForwardRef as ReactComponent };